module.exports = __webpack_public_path__ + "static/media/logo.3ad88754.png";